import { Alert, Card, Col, Row } from 'react-bootstrap';

const SupplierCustomerCard = ({ booking }) => {
    return (
        <Card className="shadow-sm border-0">
            <Card.Header className="bg-white fw-semibold">Customer Information</Card.Header>
            <Card.Body>
                <Row className="g-3">
                    <Col md={6}>
                        <div className="text-muted small">Name</div>
                        <div>{booking.customerName}</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">Language</div>
                        <div>{booking.customerLanguage}</div>
                    </Col>

                    <Col md={6}>
                        <div className="text-muted small">License</div>
                        <div>{booking.customerLicense}</div>
                    </Col>
                </Row>

                {booking.showCustomerContact ? (
                    <Row className="g-3 mt-1">
                        <Col md={6}>
                            <div className="text-muted small">Email</div>
                            <div>{booking.customerEmail}</div>
                        </Col>
                        <Col md={6}>
                            <div className="text-muted small">Phone</div>
                            <div>
                                {booking.customerPhonePrefix} {booking.customerPhone}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Alert variant="light" className="mt-3 mb-0">
                        Customer contact details will be available after booking confirmation.
                    </Alert>
                )}
            </Card.Body>
        </Card>
    );
};

export default SupplierCustomerCard;